import {useCallback} from 'react';

import {RolesAccount} from '@/app/auth/constants/AuthConstants';
import {CREATE_TEEN_EVENTS} from '@/app/auth/events/CreateTeenEvents';
import {INVITATION_TEEN_EVENTS} from '@/app/auth/events/InvitationTeenEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackSelectBackTeenInformationConfirmData = useCallback(() => {
    trackEvent(
      INVITATION_TEEN_EVENTS.SELECT_BACK_TEEN_INFORMATION_CONFIRM_DATA,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  const trackSelectAddKidEmailPhoneContinue = useCallback(
    (noPhone: boolean, themeSelected: string, parentId: string) => {
      trackEvent(CREATE_TEEN_EVENTS.SELECT_ADD_KID_EMAIL_PHONE_CONTINUE, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        user: {
          role: RolesAccount.PARENT,
          id: parentId,
        },
        Banking: {
          card: {
            theme: {
              name: themeSelected,
            },
          },
        },
        FamilyMember: {
          no_phone: noPhone,
        },
      });
    },
    [trackEvent],
  );

  const trackViewAddKidEmailPhone = useCallback(() => {
    trackEvent(CREATE_TEEN_EVENTS.VIEW_ADD_KID_EMAIL_PHONE, {
      project_tag: PROJECT_TAGS.ONBOARDING,
    });
  }, [trackEvent]);

  return {
    trackSelectBackTeenInformationConfirmData,
    trackSelectAddKidEmailPhoneContinue,
    trackViewAddKidEmailPhone,
  };
};
